module.exports = {
      id: "icon-apple-usage",
      viewBox: "0 0 13.204 15.712",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-apple",
      toString: function () {
        return this.url;
      }
    }